import React from 'react';
import { useStyles, AntTableCell, AntTableCellFilter } from '../../../../theme/Table/index';
import { Table, TableBody, TableHead, TableRow, Chip, Box } from '@mui/material';
import TableFilter from '../../../../components/global/table/TableFilter';
import dateFormat from 'dateformat';
import { PowerSettingsNew } from '@mui/icons-material';
import TableSort from '../../../../components/global/table/TableSort';
import TableNoDataComponent from '../../../../components/global/table/TableNoData';

const TableL7Resources = ({
  data,
  setFilter,
  filter,
  setIsSwitchOff,
  setIsSwitchOn,
  sortActive,
  setSortActive,
  partnerClientAccountId,
}) => {
  const classes = useStyles();

  return (
    <>
      <Table>
        <TableHead>
          <TableRow>
            <AntTableCell>
              <TableSort
                name="sortL7ResourceId"
                direction={filter?.sort?.sortL7ResourceId}
                label="ID"
                setFilter={setFilter}
                sortActive={sortActive}
                setSortActive={setSortActive}
                filter={filter}
                type={'FILTER_ACTIVE'}
              />
            </AntTableCell>
            <AntTableCell>
              <TableSort
                name="sortL7ResourceName"
                direction={filter?.sort?.sortL7ResourceName}
                label="Resource name"
                setFilter={setFilter}
                sortActive={sortActive}
                setSortActive={setSortActive}
                filter={filter}
                type={'FILTER_ACTIVE'}
              />
            </AntTableCell>
            <AntTableCell>Service IP</AntTableCell>
            <AntTableCell>L7 Protection</AntTableCell>
            <AntTableCell>Active bot protection</AntTableCell>
            <AntTableCell>Created At</AntTableCell>
            <AntTableCell>Status</AntTableCell>
          </TableRow>
          <TableRow>
            <AntTableCellFilter>
              <TableFilter
                name="l7ResourceId"
                setFilter={setFilter}
                filter={filter}
                type={'FILTER_ACTIVE'}
              />
            </AntTableCellFilter>
            <AntTableCellFilter>
              <TableFilter
                name="l7ResourceName"
                setFilter={setFilter}
                filter={filter}
                type={'FILTER_ACTIVE'}
              />
            </AntTableCellFilter>
            <AntTableCellFilter>
              <TableFilter
                name="serviceIp"
                setFilter={setFilter}
                filter={filter}
                type={'FILTER_ACTIVE'}
              />
            </AntTableCellFilter>
            <AntTableCellFilter />
            <AntTableCellFilter />
            <AntTableCellFilter />
            <AntTableCellFilter />
            <AntTableCellFilter />
          </TableRow>
        </TableHead>
        <TableBody>
          {data && data.l7Resources.items.length !== 0 ? (
            data.l7Resources.items.map(
              ({
                protectedIp,
                l7ResourceId,
                createdAt,
                l7ResourceName,
                iauthDisableL7,
                serviceAbpMode,
                active,
                l7Protection,
                advancedProtection,
              }) => (
                <TableRow hover key={l7ResourceId}>
                  <AntTableCell component="th" scope="row">
                    {l7ResourceId}
                  </AntTableCell>
                  <AntTableCell>{l7ResourceName}</AntTableCell>
                  <AntTableCell>{protectedIp}</AntTableCell>
                  <AntTableCell>
                    {l7Protection ? (
                      <Chip
                        label="Active"
                        style={{ color: '#00C853', background: '#ECF9F3', padding: '0 20px' }}
                      />
                    ) : (
                      <Chip label="Disabled" style={{ padding: '0 20px' }} />
                    )}
                  </AntTableCell>
                  <AntTableCell>
                    {!advancedProtection ? (
                      <Chip label="Disabled" style={{ padding: '0 20px' }} />
                    ) : (
                      <Chip
                        label="Active"
                        style={{ color: '#00C853', background: '#ECF9F3', padding: '0 20px' }}
                      />
                    )}
                  </AntTableCell>
                  <AntTableCell>{dateFormat(createdAt, 'dd/mm/yy hh:MM:ssTT')}</AntTableCell>
                  <AntTableCell align="left">
                    {!active ? (
                      <Box
                        className={classes.statusWrapper}
                        onClick={(e) => {
                          setIsSwitchOn({
                            switchOn: true,
                            name: l7ResourceName,
                            l7ResourceId: l7ResourceId,
                            partnerClientAccountId,
                          });
                        }}
                      >
                        <PowerSettingsNew className={classes.iconPowerOff} />
                        <div style={{ margin: '3px 0 0 3px' }}>Off</div>
                      </Box>
                    ) : (
                      <Box
                        className={classes.statusWrapper}
                        onClick={(e) => {
                          setIsSwitchOff({
                            switchOff: true,
                            name: l7ResourceName,
                            l7ResourceId: l7ResourceId,
                            partnerClientAccountId,
                          });
                        }}
                      >
                        <PowerSettingsNew className={classes.iconPowerOn} />
                        <div style={{ margin: '3px 0 0 3px' }}>On</div>
                      </Box>
                    )}
                  </AntTableCell>
                </TableRow>
              )
            )
          ) : (
            <TableNoDataComponent colSpan={7} />
          )}
        </TableBody>
      </Table>
    </>
  );
};
export default TableL7Resources;
